import React from "react";
import { Box, Heading } from "@origin-digital/ods-core";

export const PageTitleSection = () => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      gap={["small", "medium"]}
      data-id="pageTitleSection.root"
    >
      <Heading variant="h3">Tasks</Heading>
    </Box>
  );
};
